import Template from './Superscript.hbs';
import Button from 'views/components/wysiwyg/parts/buttons/Button';

export default class Superscript extends Button {

    // TinyMCE command as default or defined in wysiwyg.js
    command = 'ToggleSuperscript'
    commandQueryName = 'Superscript'

    // Initialize function for initializing button specific logic
    initializeButton() {

        // Set the icon to the template
        this.icon = Template();

        // Set the tooltip to a translated string
        this.tooltip = window.i18n.gettext('Superscript');
    }

    addCommands(editorObject) {
        const editor = editorObject.editor

        editor.addCommand('ToggleSuperscript', () => {
            // Request the state of the subscript form the editor, if true, toggle it off.
            if (editor.queryCommandState('Subscript')) {
                editor.execCommand('Subscript')
            }
            editor.execCommand('Superscript')
        })
    }

}
